import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResultModel } from 'src/app/core/models/response/base.model';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable()
export class CheckedInService {

  constructor(private apiService: ApiService) {}

  checkedIn(reqModel): Observable<ResultModel> {
    const route = "/guest/checkIn";
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getBookingDetails(reqModel): Observable<ResultModel> {
    const route = "/guest/booking";
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  guestEmailActivation(reqModel): Observable<ResultModel> {
    const route = "/hotel/guestEmailActivation";
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  guestEmailResendActivation(reqModel): Observable<ResultModel> {
    const route = "/hotel/guestResendActivation";
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  addRequestServicesAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/request-services-admin';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getPreference(reqModel): Observable<ResultModel> {
    const route = "/getCheckInPreferences";
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getUserSelectedPreferences(reqModel): Observable<ResultModel> {
    const route = "/guest/getUserSelectedPreferences";
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  addCheckInUserSelectedPreference(reqModel): Observable<ResultModel> {
    const route = "/guest/addCheckInUserSelectedPreference";
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  addGuestPreference(reqModel): Observable<ResultModel> {
    const route = "/guest/add-guest-preferences";
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getPerferencesByType(reqModel): Observable<ResultModel> {
    const route = '/guest/preference';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  // /hotel/showRestaurantOrderLists
  getRestaurantOrderLists(reqModel): Observable<ResultModel> {
    const route = '/hotel/showRestaurantOrderLists';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  getGuestRestaurantOrderLists(reqModel): Observable<ResultModel> {
    const route = '/guest/get-order-list';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getCheffStaffLists(reqModel): Observable<ResultModel> {
    const route = '/hotel/showRestaurantChefLists';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  listServices(reqModel): Observable<ResultModel> {
    const route = '/hotel/list-services';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getServiceslist(reqModel): Observable<ResultModel> {
    const route = '/hotel/get-service-list';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  signupGuest(reqModel): Observable<ResultModel> {
    const route = '/signup';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  loginGuest(reqModel): Observable<ResultModel> {
    const route = '/login';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  /**
   * Adds request services
   * @param reqModel
   * @returns request services
   */
  addRequestServices(reqModel): Observable<ResultModel> {
    const route = '/hotel/request-services';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  // addRequestServicesAdmin(reqModel): Observable<ResultModel> {
  //   const route = '/hotel/request-services-admin';
  //   return this.apiService.post<ResultModel>(route, reqModel);
  // }

  getrequestServices(reqModel): Observable<ResultModel> {
    const route = '/hotel/request-services';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  sendMessageRequests(reqModel): Observable<ResultModel> {
    const route = '/check-in/request/message';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getMessageRequests(reqModel): Observable<ResultModel> {
    const route = '/check-in/request/message';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  deleteRequestSingleMessage(reqModel): Observable<ResultModel> {
    const route = '/check-in/deleteRequestSingleMessage';
    return this.apiService.deleteWithBody<ResultModel>(route, reqModel);
  }
  
  cancelRequest(reqModel):Observable<ResultModel> {
    const route = '/check-in/request/cancel-service';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getGuestDetail(reqModel): Observable<ResultModel> {
    const route = '/check-in/get-guest-detail';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getLoginGuestDetail(reqModel): Observable<ResultModel> {
    const route = '/log-in/get-login-guest-detail';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getRequest(reqModel): Observable<ResultModel> {
    const route = '/guest/get-request';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getHotelName(reqModel): Observable<ResultModel> {
    const route = '/check-in/get-hotel-name';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  
  getGuestPreferences(reqModel): Observable<ResultModel> {
    const route = '/check-in/get-guest-preferences';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getBillingInfo(reqModel): Observable<ResultModel> {
    const route = '/check-in/get-billing-info';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  urlBillingInfo(reqModel): Observable<ResultModel> {
    const route = '/hotel/paymentMethod/checkout/executePaypalPayment';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  guestCheckoutPaypal(reqModel): Observable<ResultModel> {
    const route = '/hotel/paymentMethod/guestCheckoutPaypal';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getPaymentConnection(reqModel): Observable<ResultModel> {
    const route = "/hotel/paymentMethod/paymentConnection";
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getGuestProfile(reqModel): Observable<ResultModel> {
    const route = '/check-in/get-guest-profile';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getGuestUpdatedDetails(reqModel): Observable<ResultModel> {
    const route = '/check-in/getGuestUpdatedDetails';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  assignGuestRoomNumber(reqModel): Observable<ResultModel> {
    const route = '/check-in/assign-room-number';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  postGuestProfile(reqModel): Observable<ResultModel> {
    const route = '/check-in/post-guest-profile';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  checkedOut(reqModel): Observable<ResultModel> {
    const route = "/guest/checkOut";
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  fetchRecommendedService(reqModel): Observable<ResultModel> {
    const route = '/check-in/fetch-recommended-service';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  paymentCheckout(reqModel): Observable<ResultModel> {
    const route = '/hotel/paymentMethod/checkout';
    return this.apiService.post<ResultModel>(route, reqModel);
  }
  paymentBillCheckout(reqModel): Observable<ResultModel>{
    const route ='/hotel/paymentMethod/checkout/pendingBillsCheckout';
    return this.apiService.post<ResultModel>(route, reqModel);

  }


  bookingPaymentCheckout(reqModel): Observable<ResultModel> {
    const route = '/hotel/paymentMethod/bookingPaymentCheckout';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  resturantPaymentCheckout(reqModel): Observable<ResultModel> {
    return this.apiService.post<ResultModel>('/hotel/paymentMethod/resturantCheckout', reqModel);
  }
   PendingPaypalCheckout(reqModel) :Observable<ResultModel>{
    const route = '/hotel/paymentMethod/checkout/paypalPendingBillsCheckout';
    return this.apiService.post<ResultModel>(route, reqModel)
   }

   
  PayAtReception(reqModel): Observable<ResultModel> {
    return this.apiService.post<ResultModel>(
      '/hotel/paymentMethod/checkout/payAtReception', reqModel);
  }
  inclusiveRestaurantBookingStatus(reqModel): Observable<ResultModel> {
    return this.apiService.post<ResultModel>(
      '/hotel/paymentMethod/checkout/inclusiveRestaurantBookingStatus', reqModel);
  }
  resturantPaypalCheckout(reqModel): Observable<ResultModel> {
    return this.apiService.post<ResultModel>('/hotel/paymentMethod/checkout/resturantPaypalCheckout', reqModel);
  }
  
   servicePaymentCheckout(reqModel) :Observable<ResultModel> {
    const route = '/hotel/paymentMethod/checkout';
    return this.apiService.post<ResultModel>(route, reqModel);
   }
  //  servicePaypalCheckout(reqModel) :Observable<ResultModel>{
  //   const route = '/hotel/paymentMethod/checkout/resturantPaypalCheckout';
  //   return this.apiService.post<ResultModel>(route, reqModel)
  //  }
   guestUpdatePhoneEmail(reqModel) :Observable<ResultModel> {
    const route = '/check-in/guest-email-phoneNumber-update';
    return this.apiService.post<ResultModel>(route, reqModel);
   }
   verifyGuestOtpEmailPhone(reqModel) :Observable<ResultModel> {
    const route = '/check-in/guest-email-phoneNumber-verification';
    return this.apiService.put<ResultModel>(route, reqModel);
   }
   manageGuestTwoFa(reqModel) :Observable<ResultModel> {
    const route = '/check-in/manage-guest-two-fa';
    return this.apiService.post<ResultModel>(route, reqModel);
   }
    forgotPassword(reqModel) :Observable<ResultModel> {
    const route = '/forgotPassword';
    return this.apiService.post<ResultModel>(route, reqModel);
   }
//  /forgotPassword
// /resetPassword/:token
    resetPassword( reqModel, secret) :Observable<ResultModel> {
    const route = `/resetPassword/${secret}`;
    return this.apiService.post<ResultModel>(route, reqModel);
   }
   twoFAGuestVerification(reqModel) :Observable<ResultModel> {
    const route = '/check-in/two_fa_guest_verification';
    return this.apiService.post<ResultModel>(route, reqModel);
   }
   twoFAGuestOtp(reqModel) :Observable<ResultModel> {
    const route = '/check-in/guest_two_fa_email_otp';
    return this.apiService.post<ResultModel>(route, reqModel);
   }
   twoFAGuestEmailVerification(reqModel) :Observable<ResultModel> {
    const route = '/check-in/guest_two_fa_email_verification';
    return this.apiService.post<ResultModel>(route, reqModel);
   }
   twoFAGuestOtpMobile(reqModel) :Observable<ResultModel> {
    const route = '/check-in/resend_guest_Otp_phone_num';
    return this.apiService.post<ResultModel>(route, reqModel);
}
    emailPhoneVerificationGuestbyAdmin(reqModel) :Observable<ResultModel> {  
    const route = '/hotel/emailPhoneVerificationGuest';
    return this.apiService.put<ResultModel>(route, reqModel);
   }  
    emailPhoneUpdateGuestbyAdmin(reqModel) :Observable<ResultModel> {
    const route = '/hotel/emailAndNumberUpdateGuest';
    return this.apiService.post<ResultModel>(route, reqModel);
    }

}
